/*"operateAtFrom": "2023-04-04 12:00:00",
  "operateAtTo": "2023-04-04 12:00:00",
  "operateDescription": "统一登录",
  "operateType": 1,
  "operateTypeName": "员工登录",
  "page": 1,
  "perPage": 10,
  "userId": "uuid",
  "userPhone": ""*/

export default [
  {
    title: '用户名称',
    dataIndex: 'userName',
    key: 'userName',
    width: 150
  },
  {
    title: '用户名称',
    dataIndex: 'operatorName',
    key: 'operatorName',
    width: 150
  },
  {
    title: 'IP 地址/归属地',
    dataIndex: 'requestIp',
    key: 'requestIp',
    width: 250,
    scopedSlots: { customRender: 'requestIp' }
  },
  {
    title: '日志类型',
    dataIndex: 'logType',
    key: 'logType',
    width: 150,
    scopedSlots: { customRender: 'logType' }
  },
  {
    title: '操作描述',
    dataIndex: 'description',
    key: 'description',
    scopedSlots: { customRender: 'description' }
  },
  {
    title: '操作时间',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 200
  }
]
